<template>
    <div class="container">
        <!-- <div class="titleBox">欢迎使用龙猫智能健康助手</div> -->
      <!-- 消息容器 -->
      <div class="message-container" ref="messageContainer">
        <div class="welcomeBox" v-show="messages.length === 0">
          <!-- <div class="imgbox">
            <img src="@/assets/background/loginLog.jpg" width="100%" height="100%" alt="">
          </div> -->
          <!-- <div style="text-align: center;margin-top: 6px;font-size: 14px;margin-bottom: 20px;">龙猫运动健康顾问</div> -->

          <h2>嗨，大家好！</h2>
          <div>我致力于为大家提供专业的运动与营养建议。</div>
        </div>
        <div 
          v-for="(message, index) in messages"
          :key="index"
          :class="['message', message.role]"
        >
          <div class="content">
          
          <vue-markdown :source="message.reasoning_content"  style="color: #727070;border-left: 2px solid #ccc7c7;padding-left: 4px;margin-bottom: 12px;"  v-show="message.reasoning_content&&message.reasoning_content!==''"></vue-markdown>
          <vue-markdown :source="message.content"></vue-markdown>

          <div v-if="isLoading && index === messages.length - 1" class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
          </div>
          </div>


          <!-- createTime -->
        </div>


      </div>
  
      <!-- 输入区 -->
      <div class="input-area">
        <textarea
          v-model="inputMessage"
          placeholder="输入你的问题，例如：张三同学的锻炼成绩..."
          @keyup.enter.exact.prevent="sendMessage"
          rows="2"
          ref="textarea"
        ></textarea>
        <button 
          @click="sendMessage"
          :disabled="isLoading || !inputMessage.trim()"
        >
          <span v-if="!isLoading">发送</span>
          <div v-else class="loader"></div>
        </button>
      </div>
      <div class="bottomBox">
        <div class="rechargeBox">
          <img src="@/assets/image/充电.png" height="70%" alt="">
          <span style="font-size: 12px;">{{10 - this.getChatAllCount() }}</span>
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import VueMarkdown from 'vue-markdown'
  import moment from 'moment'

  export default {
    components: {
    VueMarkdown
  },
    data() {
      return {

        

        // { role: 'assistant', content:'嗨，大家好！我致力于为大家提供专业的运动与营养建议。' }
        messages: [],       // 消息列表
        inputMessage: '',    // 输入内容
        isLoading: false,    // 加载状态
        
        apiKey: 'pat_6AJO3ViaQXYErlHw7pg5Y7QS4GDDeLdMS1jMxVZNle66w8FYVN59dczFObDUmI3C', // 替换为你的API Key
        apiUrl: 'https://api.coze.cn/v3/chat', // 替换为你的API地址
        checkInterval:null,
        chat_Data:{
          rechargeNum:10,
          rechargeNum_time:null
        },
        formData: {
        bot_id: "7493714784261636137",
        conversation_id: "",
        chat_id: "",
        user_id: "123123",
          stream: true,
          auto_save_history: true,
          custom_variables:{
            preposition:'',
          },
         additional_messages:[
                {
                    "role":"user",
                    "content":'',
                    "content_type":"text",
                    "type": "question"
                }
            ],
        },
      }
    },
    mounted() {
      
      let conversation_id = localStorage.getItem('conversation_id');
      let chat_id = localStorage.getItem('chat_id');
      let chat_messages = JSON.parse(localStorage.getItem('chat_messages'))
      // let chat_Data = JSON.parse(localStorage.getItem('chat_Data'))

      this.formData.user_id = localStorage.getItem('openId')
      if (conversation_id&&conversation_id!=='') {
        this.conversation_id = conversation_id
        this.chat_id = chat_id
        this.messages = chat_messages||[]
        this.scrollToBottom();
        // this.checkStatus(conversation_id,chat_id)
      }
      console.log('getChatAllCount',this.getChatAllCount());

      // if (chat_Data&&chat_Data!=='') {
      //   if (moment(this.chat_Data.rechargeNum_time).isSame(moment(new Date()).format("YYYY-MM-DD"), 'day') ) {
      //   this.chat_Data = chat_Data
      //   }
      // }
    },
    methods: {
      getChatAllCount(){
        let count = 0
        this.messages?.forEach(el=>{
          if (el.role === 'user'&&moment(el.createTime).isSame(moment(new Date()).format("YYYY-MM-DD"), 'day')) {
            count++
          }
        })
        return count
      },

        async sendMessage() {
    let getChatAllCount = this.getChatAllCount()
if (10 - getChatAllCount==0) {
  this.$toast(
  {
  message: '额度已用尽！',
  position: 'top',
  });
  
  return
}

            if (!this.inputMessage.trim() || this.isLoading) return
  
  try {
    const userMessage = this.inputMessage
    this.messages.push({ role: 'user', content: userMessage,createTime:moment(new Date()).format("YYYY-MM-DD HH:mm:ss") })
    this.inputMessage = ''
    this.isLoading = true
    this.messages.push({ role: 'assistant', content:'',reasoning_content:'' })
    this.formData.additional_messages[0].content = userMessage
    this.formData.studentName = '杨森'
    
    let url = 'https://api.coze.cn/v3/chat';
    if (this.conversation_id&&this.conversation_id!=='') {
        url =  `https://api.coze.cn/v3/chat?conversation_id=${this.conversation_id}`
    }
    const response = await fetch(url, {
            method: 'POST',
            headers: {
             'Authorization':'Bearer pat_6AJO3ViaQXYErlHw7pg5Y7QS4GDDeLdMS1jMxVZNle66w8FYVN59dczFObDUmI3C',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.formData)
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let accumulatedData = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            
            if (decoder.decode(value, { stream: true }).startsWith('event:conversation.message.delta')) {
                
            accumulatedData += decoder.decode(value, { stream: true });
            
            // 按行分割数据
            const lines = accumulatedData.split('\n');
            for (const line of lines) {
                if (line.startsWith('data:')) {
                    const jsonData = line.substring(5); // 去掉 'data:' 前缀
                    
                    try {
                        const parsedData = JSON.parse(jsonData);
                        console.log('parsedData',parsedData);
                        
                        if (parsedData.reasoning_content) {
                          this.messages[this.messages.length - 1].reasoning_content += parsedData.reasoning_content;
                          this.scrollToBottom();

                        }
                        if (parsedData.content) {
                            this.messages[this.messages.length - 1].content += parsedData.content;
                            this.conversation_id = parsedData.conversation_id;
                            this.chat_id = parsedData.chat_id;
                            this.scrollToBottom();
                        }
                      
                    } catch (e) {
                        console.error('解析 JSON 数据失败:', e);
                    }
                }
            }

            
            // 如果最后一行不完整，保留它以便与下一次数据合并
            const lastLine = lines[lines.length - 1];

            if (!lastLine.endsWith('\n')) {
                accumulatedData = lastLine;
            } else {
                accumulatedData = '';
            }
        }

        }

        console.log('accumulatedData',accumulatedData);
        // 将数据缓存
        localStorage.setItem('conversation_id', this.conversation_id);
        localStorage.setItem('chat_id', this.chat_id);
        localStorage.setItem('chat_messages', JSON.stringify(this.messages));

        this.isLoading = false;
        this.scrollToBottom();


    return





await instance.post('/v3/chat',this.formData)  
  .then(res=>{
    
                console.log(res,'res');
                if (res.data && res.data) {
            this.messages[this.messages.length - 1].content = res.data
    console.log('json',JSON.parse(res.data));

          }
        // if (res.data.data.status === 'in_progress') {
        // //   this.checkStatus(res.data.data.conversation_id,res.data.data.id);
        // }
            })

     
        }  catch (error) {
          console.error('API调用失败:', error)
          this.messages[this.messages.length - 1].content = '请求失败，请重试'
        } finally {
          this.isLoading = false
          this.scrollToBottom()
        }
      },
      async checkStatus(taskId,id) {
      this.loading = true;
      const instance = axios.create({  
        baseURL: 'https://api.coze.cn',  
        timeout: 1000,  
        headers: { 'Authorization':'Bearer pat_6AJO3ViaQXYErlHw7pg5Y7QS4GDDeLdMS1jMxVZNle66w8FYVN59dczFObDUmI3C'},
        })

      this.checkInterval = setInterval(async () => {
        try {
            const responseRetrieve = await instance.get(
             `/v3/chat/retrieve`,
            {
              params:{conversation_id:taskId,chat_id:id}
            },
          );

          const response = await instance.get(
            `/v3/chat/message/list`,
            {
              params:{conversation_id:taskId,chat_id:id}
            },
          );
        //   console.log(responseRetrieve);

          console.log('response.data.data',response.data.data);
          
          if (responseRetrieve.data.data&&responseRetrieve.data.data.status === 'completed') {

            // this.prescriptionUrl = response.data.data;
              // 处理响应（假设为流式响应）
        //   if (response.data && response.data.content) {
            this.messages[this.messages.length - 1].content = response.data.data
        //   }
        // console.log('this.messages',this.messages);
        
            clearInterval(this.checkInterval);
            this.loading = false;
          } else if (responseRetrieve.data.data&&responseRetrieve.data.data.status === 'failed') {
            
            clearInterval(this.checkInterval);
            this.loading = false;
          }
        } catch (error) {
         
          clearInterval(this.checkInterval);
          this.loading = false;
          console.error(error);
        }
      }, 2000); // 每5秒检查一次状态
    },



      async sendMessagev2() {
        if (!this.inputMessage.trim() || this.isLoading) return
  
        try {
          const userMessage = this.inputMessage
          this.messages.push({ role: 'user', content: userMessage })
          this.inputMessage = ''
          
          this.isLoading = true
          this.messages.push({ role: 'assistant', content: '' })
          const instance = axios.create({  
        baseURL: this.apiUrl,  
        timeout: 1000,  
        headers: {
              Authorization: `Bearer ${this.apiKey}`,
              'Content-Type': 'application/json'
            },
        })
        this.formData.message = userMessage
          // 调用API - 根据实际API文档调整参数
          const response = await instance.post('', 
          this.formData
          )
  
          // 处理响应（假设为流式响应）
          if (response.data && response.data.content) {
            this.messages[this.messages.length - 1].content = response.data.content
          }
        } catch (error) {
          console.error('API调用失败:', error)
          this.messages[this.messages.length - 1].content = '请求失败，请重试'
        } finally {
          this.isLoading = false
          this.scrollToBottom()
        }
      },
  
      scrollToBottom() {
        this.$nextTick(() => {
          const container = this.$refs.messageContainer
          container.scrollTop = container.scrollHeight
        })
      }
    },
    watch: {
      inputMessage(val) {
        this.$nextTick(() => {
          this.$refs.textarea.style.height = 'auto'
          this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + 'px'
        })
      }
    }
  }
  </script>

  <style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    /* padding: 0 10px; */
    // background: #f5f5f5;
    // background: #fff;
    background: #fdfbfb57;
  }
  .titleBox{
    font-size: 18px;
    text-align: center;
    font-weight: normal;
  }
  .message-container {
    flex: 1;
    overflow-y: auto;
    padding: 10px 0;
    
    
  }
  .welcomeBox{
    /* background-color: #fff; */
    border-radius: 15px;
    width: 80%;
    margin: 0px auto;
    margin-top: 35%;
    .imgbox{
     border-radius: 15px;
      width: 80px;
      height: 80px;
      background-color: blue;
      margin: auto;
      overflow: hidden;
    }
  }
  .message {
    margin: 10px 0;
    display: flex;
  }
  
  .message.user {
    justify-content: flex-end;
  }
  
  .message.assistant {
    justify-content: flex-start;
  }
  
  .content {
    max-width: 80%;
    padding: 2px 15px;
    border-radius: 15px;
    word-break: break-word;
  }
  
  .user .content {
    background: #07c160;
    color: white;
  }
  
  .assistant .content {
    background: white;
    border: 1px solid #eee;
  }
  .bottomBox{
    background-color: #fff;
    padding:0px 10px ;
    padding-bottom: 24px;
    .rechargeBox{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 25px;
      background-color: #f3f0f081;
      border-radius: 18px;
      text-align: center;
      color: #817d7d;
    }

  }
  .input-area {
    display: flex;
    gap: 10px;
    padding: 10px;
    // padding-bottom: 12px;
    background: white;
    border-top: 1px solid #eee;
    border-radius: 16px;
  }
  
  textarea {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 20px;
    resize: none;
    max-height: 100px;
  }
  
  button {
    padding: 0 20px;
    border: none;
    border-radius: 20px;
    background: #07c160;
    color: white;
    cursor: pointer;
  }
  
  button:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
  
  /* 加载动画 */
  .loader {
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: rotation 1s linear infinite;
  }
  
  @keyframes rotation {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* 输入中动画 */
  .typing-indicator span {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 3px;
    background: #999;
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;
  }
  
  .typing-indicator span:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .typing-indicator span:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes typing {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }
  </style>